
import React, { useEffect, useRef, useState } from "react";

const WinLines = (Winsdata) => {
    const payoutlist = [
        { linesCount: 1, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 1, 1, 1, 1], clr: "#fa7705" }, // 1
        { linesCount: 2, backGroung_G_clr: ['#687ced', '#9c0983'], active: true, payoutLine: [0, 0, 0, 0, 0], clr: "#05fa36" }, // 2
        { linesCount: 3, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 2, 2, 2, 2], clr: "#fa7705" }, // 3
        { linesCount: 4, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 1, 2, 1, 0], clr: "#ffff" }, // 4
        { linesCount: 5, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 1, 0, 1, 2], clr: "#0c28b3" }, // 5
        { linesCount: 6, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 0, 1, 2, 1], clr: "salmon" }, // 6
        { linesCount: 7, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 2, 1, 0, 1], clr: "skyblue" }, // 7
        { linesCount: 8, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 1, 0, 1, 0], clr: "red" }, // 8
        { linesCount: 9, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 1, 2, 1, 2], clr: "firebrick" }, // 9
        { linesCount: 10, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 0, 0, 0, 1], clr: "limegreen" }, // 10
        { linesCount: 11, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 2, 2, 2, 1], clr: "darkgreen" }, // 11
        { linesCount: 12, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 0, 2, 0, 1], clr: "indianred" }, // 12
        { linesCount: 13, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 2, 0, 2, 1], clr: "navy" }, // 13
        { linesCount: 14, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 2, 1, 0, 0], clr: "darkseagreen" }, // 14
        { linesCount: 15, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 0, 1, 2, 2], clr: "crimson" }, // 15
        { linesCount: 16, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 1, 1, 1, 2], clr: "deepskyblue" }, // 16
        { linesCount: 17, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 1, 1, 1, 0], clr: "rosybrown" }, // 17
        { linesCount: 18, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 2, 0, 2, 0], clr: "yellow" }, // 18
        { linesCount: 19, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 0, 2, 0, 2], clr: "lightgreen" }, // 19
        { linesCount: 20, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 1, 0, 1, 1], clr: "hotpink" }, // 20
        { linesCount: 21, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [1, 1, 2, 1, 1], clr: "mediumpurple" }, // 21
        { linesCount: 22, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 2, 0, 2, 2], clr: "mediumblue" }, // 22
        { linesCount: 23, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 0, 2, 0, 0], clr: "darkviolet" }, // 23
        { linesCount: 24, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [2, 2, 1, 0, 1], clr: "orangered" }, // 24
        { linesCount: 25, backGroung_G_clr: ['#cb950d', '#c41d0a'], active: true, payoutLine: [0, 0, 1, 2, 1], clr: "forestgreen" }, // 25
    ]
    const ICON_WIDTH = Winsdata.Winsdata.ICON_WIDTH
    const ICON_HEIGHT = Winsdata.Winsdata.ICON_HEIGHT
    const ICON_SPACING_X = Winsdata.Winsdata.ICON_SPACING_X
    const ICON_SPACING_Y = Winsdata.Winsdata.ICON_SPACING_Y
    const X_OFFSET = Winsdata.Winsdata.X_OFFSET
    const lines_gm = Winsdata.Winsdata.Winning_Lines
    const ctx = Winsdata.Winsdata.ctx
    const reelData = Winsdata.Winsdata.reelData
    const DUMMY_LENGTH = Winsdata.Winsdata.DUMMY_LENGTH
    const preloadedImages = Winsdata.Winsdata.preloadedImages

    useEffect(() => {
        let animationFrameId;

        const animate = () => {
            // ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
            drawWinningLines(Winsdata);
            // highlightWinningIcons();
            animationFrameId = requestAnimationFrame(animate);
        };

        animate();
        return () => cancelAnimationFrame(animationFrameId);
    }, [Winsdata]);

    const drawWinningLines = (Winsdata) => {
        // console.log(Winsdata.Winsdata)
        const lines = lines_gm;
        // console.log(lines)
        if (!lines.length) return;

        lines.forEach(line => {
            ctx.save();
            ctx.beginPath();

            line.positions.forEach(([reelIndex, rowIndex], i) => {
                // Use visible row coordinates (no DUMMY addition)
                const x = reelIndex * (ICON_WIDTH + ICON_SPACING_X) + X_OFFSET + ICON_WIDTH / 2;
                const y = rowIndex * (ICON_HEIGHT + ICON_SPACING_Y) + ICON_HEIGHT / 2;

                if (i === 0) ctx.moveTo(x, y);
                else ctx.lineTo(x, y);
            });

            // pick color: prefer payoutlist by lineId if available
            let clr = "#e9b920";
            // let clr = 'red';
            if (line.lineId && payoutlist[line.lineId - 1]) {
                clr = payoutlist[line.lineId - 1].clr;
            } else if (line.clr) {
                clr = line.clr;
            }

            ctx.strokeStyle = clr;
            ctx.lineWidth = 8;
            ctx.shadowColor = clr;
            ctx.shadowBlur = 18;
            ctx.stroke();
            ctx.restore();
        });
    };

    const highlightWinningIcons = () => {
        const lines = lines_gm;
        if (!lines.length) return;

        lines.forEach(line => {
            line.positions.forEach(([reelIndex, rowIndex]) => {
                const x = reelIndex * (ICON_WIDTH + ICON_SPACING_X) + X_OFFSET;
                const y = rowIndex * (ICON_HEIGHT + ICON_SPACING_Y);

                const iconKey = reelData.current[reelIndex][rowIndex + DUMMY_LENGTH];
                const img = preloadedImages.current[iconKey];

                // 1️⃣ Draw static gradient background
                let colors = ["rgba(255, 215, 0, 0.7)", "rgba(255, 0, 0, 0.7)"];
                if (line.lineId && payoutlist[line.lineId - 1]) {
                    colors = payoutlist[line.lineId - 1].backGroung_G_clr;
                }
                const gradient = ctx.createLinearGradient(x, y, x + ICON_WIDTH, y + ICON_HEIGHT);
                gradient.addColorStop(0, colors[0]);
                gradient.addColorStop(1, colors[1]);
                ctx.fillStyle = gradient;
                ctx.fillRect(x, y, ICON_WIDTH, ICON_HEIGHT);

                // 2️⃣ Pulse only the icon
                ctx.save();
                const centerX = x + ICON_WIDTH / 2;
                const centerY = y + ICON_HEIGHT / 2;
                ctx.translate(centerX, centerY);

                const pulseSpeed = 1000; // ms
                const offset = (reelIndex + rowIndex) * 10;
                const scale =
                    1 +
                    0.1 *
                    Math.sin(
                        (((Date.now() + offset) % pulseSpeed) / pulseSpeed) *
                        2 *
                        Math.PI
                    );

                ctx.scale(scale, scale);
                ctx.translate(-centerX, -centerY);

                ctx.drawImage(img, x, y, ICON_WIDTH, ICON_HEIGHT);
                ctx.restore();

                // 3️⃣ Static glowing border
                ctx.save();
                ctx.lineWidth = 6;
                ctx.strokeStyle = "white";
                ctx.shadowColor = "yellow";
                ctx.shadowBlur = 20;
                ctx.strokeRect(x, y, ICON_WIDTH, ICON_HEIGHT);
                ctx.restore();
            });
        });
    };
}
export default WinLines